import {
  getDataListApi,
  updateDataApi,
  getDetailApi,
  getBrandList,
  getConceptList,
  getFormulationList,
  getConsumerProduct,
  getEventList,
  getBasfProduct,
  getInci,
  getTrend,
  getWebinar,
  changeStatus,
  addBanner,
  setWeight,
  checkWeight,
  delWebBanner,
  getBannerCount
} from '@/axios/api/appPictures'
import { getDicByModule } from "@/axios/api/dictionary"
import { Message } from 'element-ui'

const UPDATE_LOADING = 'UPDATE_LOADING'
const UPDATE_MODULE_LIST = 'UPDATE_MODULE_LIST'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_BANNER_LIST = 'UPDATE_BANNER_LIST'
const UPDATE_WEB_BANNER_LIST = 'UPDATE_WEB_BANNER_LIST'
const UPDATE_MODULE_PAGER = 'UPDATE_MODULE_PAGER'
const UPDATE_BANNER_PAGER = 'UPDATE_BANNER_PAGER'
const UPDATE_WEB_BANNER_PAGER = 'UPDATE_WEB_BANNER_PAGER'
const UPDATE_BANNER_DIALOG = 'UPDATE_BANNER_DIALOG'
const UPDATE_OPEN_SCREEN = 'UPDATE_OPEN_SCREEN'
const UPDATE_SELECT_MODULE = 'UPDATE_SELECT_MODULE'
const UPDATE_MODULE_DETAIL = 'UPDATE_MODULE_DETAIL'
const CLEAR_DETAIL = 'CLEAR_DETAIL'
const state = {
  isShowBannerDialog: false,
  loading: false,
  selectModuleList: [], // 选择模块下拉框
  moduleDetailList: [], // 选择模块详情下拉框
  moduleList: [],
  bannerList: [],
  webBannerList: [],
  openScreen: [],
  modulePager: {
    current: 1,
    size: 9,
    total: 0
  },
  bannerPager: {
    current: 1,
    size: 10,
    total: 0
  },
  webBannerPager: {
    current: 1,
    size: 10,
    total: 0,
    realTotal: 0
  },
  detail: {
    id: '',
    imgId: '',
    imgSrc: '',
    moduleNumber: '',
    refId: '',
    longImgSrc: '',
    longImgId: '',
    refIdName: '', // banner图选择的link 模块的refName
    moduleNumberName: '', // banner图选择的link module name
    hidden: undefined,
    languageIds: []
  }
}



const getters = {
  loading: state => state.loading,
  isShowBannerDialog: state => state.isShowBannerDialog,
  moduleList: state => state.moduleList,
  bannerList: state => state.bannerList,
  webBannerList: state => state.webBannerList,
  openScreen: state => state.openScreen,
  detail: state => state.detail,
  modulePager: state => state.modulePager,
  bannerPager: state => state.bannerPager,
  webBannerPager: state => state.webBannerPager,
  selectModuleList: state => state.selectModuleList,
  moduleDetailList: state => state.moduleDetailList,
}

const mutations = {
  [UPDATE_LOADING](state, params) {
    state.loading = params
  },
  [UPDATE_MODULE_LIST](state, params) {
    state.moduleList = params
  },
  [UPDATE_DETAIL](state, detail) {
    state.detail = {
      ...state.detail,
      ...detail
    }
  },
  [UPDATE_OPEN_SCREEN](state, params) {
    state.openScreen = params
  },
  [UPDATE_BANNER_LIST](state, params) {
    state.bannerList = params
  },
  [UPDATE_WEB_BANNER_LIST](state, params) {
    state.webBannerList = params
  },
  [UPDATE_MODULE_PAGER](state, pager) {
    state.modulePager = {
      ...state.modulePager,
      ...pager
    }
  },
  [UPDATE_BANNER_PAGER](state, pager) {
    state.bannerPager = {
      ...state.bannerPager,
      ...pager
    }
  },
  [UPDATE_WEB_BANNER_PAGER](state, pager) {
    state.webBannerPager = {
      ...state.webBannerPager,
      ...pager
    }
  },
  [UPDATE_BANNER_DIALOG](state, params) {
    state.isShowBannerDialog = params
  },
  [UPDATE_SELECT_MODULE](state, params) {
    state.selectModuleList = params
  },
  [UPDATE_MODULE_DETAIL](state, params) {
    state.moduleDetailList = params
  },
  [CLEAR_DETAIL](state, params) {
    state.detail = {
      id: '',
      imgId: '',
      imgSrc: '',
      moduleNumber: '',
      refId: '',
      longImgSrc: '',
      longImgId: '',
      refIdName: '', // banner图选择的link 模块的refName
      moduleNumberName: '', // banner图选择的link module name
      hidden: undefined,
      ...params,
    }
  }
}

const actions = {
  changeLoading({ commit }, params) {
    commit(UPDATE_LOADING, params)
  },
  // 获取模块主图列表
  async getModuleList({ commit, state }) {
    commit(UPDATE_LOADING, true)
    try {
      let { data: res } = await getDataListApi({ type: 1, ...state.modulePager })
      commit(UPDATE_MODULE_LIST, res.records)
      const { current, size, total } = res
      commit(UPDATE_MODULE_PAGER, { current, size, total })
    } catch (e) {
      commit(UPDATE_LOADING, false)
    }
    commit(UPDATE_LOADING, false)
  },
  // 获取banner列表
  async getBannerList({ commit }, params) {
    commit(UPDATE_LOADING, true)
    try {
      let { data: res } = await getDataListApi({ type: 2, ...state.bannerPager, ...params })
      commit(UPDATE_BANNER_LIST, res.records)
      const { current, size, total } = res
      commit(UPDATE_BANNER_PAGER, { current, size, total })
    } catch (e) {
      commit(UPDATE_LOADING, false)
    }
    commit(UPDATE_LOADING, false)
  },
  // 获取web_banner列表
  async getWebBannerList({ commit }, params) {
    commit(UPDATE_LOADING, true)
    try {
      let { data: res } = await getDataListApi({ type: 4, ...state.webBannerPager, ...params })
      commit(UPDATE_WEB_BANNER_LIST, res.records)
      const { current, size, total } = res
      commit(UPDATE_WEB_BANNER_PAGER, { current, size, total })
    } catch (e) {
      commit(UPDATE_LOADING, false)
    }
    commit(UPDATE_LOADING, false)
  },
  // 获取open screen
  async getOpenScreen({ commit }) {
    commit(UPDATE_LOADING, true)
    try {
      let { data: res } = await getDataListApi({ type: 3 })
      commit(UPDATE_OPEN_SCREEN, res.records || {})
    } catch (e) {
      commit(UPDATE_LOADING, false)
    }
    commit(UPDATE_LOADING, false)
  },
  // 更新当前操作的数据
  updateDetail({ commit, state }, detail) {
    commit(UPDATE_DETAIL, { ...state.state, ...detail })
  },
  // 获取详情
  async getDetail({ commit }, id) {
    commit(UPDATE_LOADING, true)
    try {
      let { data: detail } = await getDetailApi({ id })
      // 新增时，link选择event模块，refId需要拼接成id_type形式，非数字类型，不用转换
      // 其他模块只需要id，回显时前端id为int类型，后台返回sting，需要转换
      if (!isNaN(detail.refId)) {
        if (detail.refId !== '') {
          detail.refId = Number(detail.refId)
        }
      }
      commit(UPDATE_DETAIL, {
        ...detail,
        languageIds: detail.languageIds ? detail.languageIds.split(',').map(v => Number(v)) : []
      })
      commit(UPDATE_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_LOADING, false)
      return false
    }
    commit(UPDATE_LOADING, false)

  },
  // 提交编辑
  async updateData({ commit }) {
    commit(UPDATE_LOADING, true)
    try {
      let params = { ...state.detail }
      delete params.updateTime
      delete params.createTime
      let res = await updateDataApi(params)
      return res
    } catch (e) {
      commit(UPDATE_LOADING, false)
      return false
    }
  },
  updateBannerDialog({ commit }, params) {
    // if (!params) {
    // 	// 关闭编辑banner时，初始化detail
    // 	let detail = {
    // 		position: '',
    // 		id: '',
    // 		imgId: '',
    // 		imgSrc: '',
    // 		moduleNumber: '',
    // 		refId: '',
    // 		longImgSrc: '',
    // 		longImgId: '',
    // 		refIdName: '',
    // 		moduleNumberName: ''
    // 	}
    // 	commit(UPDATE_DETAIL, detail)
    // }
    commit(UPDATE_BANNER_DIALOG, params)
  },
  changePage({ commit }, params) {
    let { current } = params
    if (params.type == 'modulePicture') {
      commit(UPDATE_MODULE_PAGER, { current })
    } else if (params.type == 'banner') {
      commit(UPDATE_BANNER_PAGER, { current })
    } else if (params.type == 'webBanner') {
      commit(UPDATE_WEB_BANNER_PAGER, { current })
    }
  },
  // 获取模块下拉列表
  async getSelectModuleList({ commit }, type) {
    commit(UPDATE_LOADING, true)
    try {
      let { data } = await getDicByModule()
      // 过滤模块
      let newList = filteSelectModule(data, type)
      commit(UPDATE_SELECT_MODULE, newList)
    } catch (e) {
      commit(UPDATE_LOADING, false)
    }
    commit(UPDATE_LOADING, false)
  },
  // 获取各个模块二级下拉列表
  async getRefList({ commit, state }, { id, keyword }) {
    if (id == -1) {
      let detailList = [{ id: -1, name: 'Long image' }]
      commit(UPDATE_MODULE_DETAIL, detailList)
      commit(UPDATE_DETAIL, { refId: -1 })
    }
    if (id === 681) {
      let detailList = [{ id: '0', name: 'Video module' }]
      commit(UPDATE_MODULE_DETAIL, detailList)
      commit(UPDATE_DETAIL, { refId: '0' })
    }
    if (!id) {
      commit(UPDATE_MODULE_DETAIL, [])
    }
    commit(UPDATE_LOADING, true)
    try {
      let detailList = await getDataFn[id]({ keyword })
      commit(UPDATE_MODULE_DETAIL, detailList)
    } catch (e) {
      commit(UPDATE_LOADING, false)
    }
    commit(UPDATE_LOADING, false)
  },
  setRefList({ commit, state }, detailList) {
    commit(UPDATE_MODULE_DETAIL, detailList)
  },
  // 切换banner状态
  async changeStatusApi({ commit }, params) {
    commit(UPDATE_LOADING, true)
    try {
      let res = await changeStatus(params)
      Message.success('success')
      commit(UPDATE_LOADING, false)
      return res
    } catch (e) {
      commit(UPDATE_LOADING, false)
      return false
    }
  },
  // 删除web banner
  async delWebBannerApi({ commit }, params) {
    try {
      let res = await delWebBanner(params)
      // Message.success('success')
      return res
    } catch (e) {
      return false
    }
  },
  // 新增banner
  async addBannerApi({ commit }) {
    commit(UPDATE_LOADING, true)
    try {
      let params = { ...state.detail }
      delete params.updateTime
      delete params.createTime
      await addBanner(params)
      Message.success('success')
      commit(UPDATE_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_LOADING, false)
      return false
    }
  },
  // 验证weight
  async checkWeightApi({ commit }, params) {
    try {
      const res = await checkWeight(params)
      return res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  // 设置weight
  async setWeightApi({ commit }, params) {
    try {
      const res = await setWeight(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 获取banner 数量
  async getBannerCountApi({ commit }, params) {
    try {
      const { data: res } = await getBannerCount(params)
      commit(UPDATE_WEB_BANNER_PAGER, { realTotal: res })
    } catch (e) {
      return false
    }
  }
}
// 过滤模块列表 type: banner || openScreen
function filteSelectModule(data, type) {
  let filter = [] // 需要过滤掉的模块
  if (type === 'banner') {
    filter = [288, 289, 273]
  } else if (type === 'webBanner') {
    filter = [288, 289, 273]
  }
  let newList = data.filter(modules => {
    if (!filter.includes(modules.id)) {
      return modules
    }
  })
  // data 为module列表，banner图选择时要加上长图片类型
  if (type && type == 'banner') {
    let longImage = {
      name: 'Long image',
      id: -1
    }
    newList.push(longImage)
  }

  return newList
}

// 通过模块id查询下拉数据
function getSelectData(id) {
  getDataFn[id]
}

const getDataFn = {
  292: async function (params) {
    try {
      let { data } = await getBrandList(params)
      return data
    } catch (e) {
      return []
    }

  },
  263: async function (params) {
    try {
      let { data } = await getTrend(params)
      //  处理数据，只需要id和name
      return data.map(value => {
        return {
          id: value.id,
          name: value.title
        }
      })
    } catch (e) {
      return []
    }

  },
  290: async function (params) {
    try {
      let { data } = await getWebinar(params)
      //  处理数据，只需要id和name
      return data.map(value => {
        return {
          id: value.id,
          name: value.title
        }
      })
    } catch (e) {
      return []
    }

  },
  264: async function (params) {
    try {
      let { data } = await getConceptList(params)
      //  处理数据，只需要id和name
      return data.map(value => {
        return {
          id: value.id,
          name: value.internationalTitle
        }
      })
    } catch (e) {
      return []
    }

  },
  265: async function (params) {
    try {
      let { data } = await getConsumerProduct(params)
      //  处理数据，只需要id和name
      return data.list.map(value => {
        return {
          id: value.id,
          name: value.title
        }
      })
    } catch (e) {
      return []
    }

  },
  266: async function (params) {
    try {
      let { data } = await getFormulationList(params)
      //  处理数据，只需要id和name
      return data.list.map(value => {
        return {
          id: value.id,
          name: value.title
        }
      })
    } catch (e) {
      return []
    }

  },
  271: async function (params) {
    try {
      let { data } = await getBasfProduct(params)
      //  处理数据，只需要id和name
      return data.records.map(value => {
        return {
          id: value.id,
          name: value.tradeName
        }
      })
    } catch (e) {
      return []
    }

  },
  272: async function (params) {
    try {
      let { data } = await getInci({
        ...params,
        inciParam: params.keyword
      })
      //  处理数据，只需要id和name
      return data.map(value => {
        return {
          id: value.id,
          name: value.inciName
        }
      })
    } catch (e) {
      return []
    }

  },
  291: async function (params) {
    try {
      let { data } = await getEventList(params)
      //  处理数据，只需要id和name
      return data.map(value => {
        return {
          id: value.id,
          name: value.eventName
        }
      })
    } catch (e) {
      return []
    }

  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/appPictures.js